import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function Icon10(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 15, 18);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 15 18" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path fill="currentColor" d="M7.408 3V0l-5.61 4 5.61 3.94V5a5.54 5.54 0 0 1 1.9 10.48v2.12A7.5 7.5 0 0 0 7.408 3M2.05 10.3h1.1v5.67h-1.1v-4.35l-1.05.7v-1.04Z" /><path fill="currentColor" d="M6.348 10.12q.832 0 1.3.594.56.703.559 2.332 0 1.625-.562 2.336-.466.585-1.297.586-.837 0-1.348-.64-.512-.645-.512-2.294 0-1.617.563-2.328.465-.585 1.297-.586m0 .91a.54.54 0 0 0-.356.13q-.156.123-.242.452-.114.426-.113 1.434 0 1.008.101 1.386.102.375.254.5a.55.55 0 0 0 .356.125.55.55 0 0 0 .355-.125q.156-.128.242-.457.114-.42.114-1.43 0-1.007-.102-1.382-.102-.379-.258-.504a.53.53 0 0 0-.351-.129" /></svg>
  );
}

export default Icon10;
